import type { IconProps } from './types';

export const TwoPaneIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M19.6067 5.03544C19.6065 4.68052 19.3191 4.39286 18.9641 4.39286H12.7502V19.6067H18.9641C19.3192 19.6067 19.6067 19.3192 19.6067 18.9641V5.03544ZM4.39282 18.9641C4.39282 19.3191 4.68049 19.6066 5.0354 19.6067H11.2502V4.39286H5.0354C4.68059 4.39301 4.39297 4.68062 4.39282 5.03544V18.9641ZM21.1067 18.9641C21.1067 20.1476 20.1476 21.1067 18.9641 21.1067H5.0354C3.85208 21.1066 2.89282 20.1476 2.89282 18.9641V5.03544C2.89297 3.8522 3.85216 2.89301 5.0354 2.89286H18.9641C20.1475 2.89286 21.1065 3.85211 21.1067 5.03544V18.9641Z"
        fill={color}
      />
    </svg>
  );
};
